import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

import { ApiError } from '../api/errors'
import { operatorMessage } from '../api/messages'

interface Props {
  error: unknown
  onRetry?: () => void
}

/**
 * Renders a failed request.
 *
 * The request id is shown deliberately. It is the one value that ties what the
 * operator saw to the server's logs, the trace and the financial record, and
 * asking someone to describe a failure without it wastes everyone's time.
 */
export function QueryError({ error, onRetry }: Props) {
  const apiError = error instanceof ApiError ? error : null
  // Normalised: a customer must never be shown an exception message.
  const message = operatorMessage(error)

  return (
    <Alert
      severity={apiError?.isAuthenticationFailure ? 'warning' : 'error'}
      action={
        onRetry ? (
          <Button color="inherit" size="small" onClick={onRetry}>
            تلاش دوباره
          </Button>
        ) : undefined
      }
    >
      <AlertTitle>
        {apiError?.isAuthenticationFailure ? 'نشست شما منقضی شده است' : 'بارگذاری ممکن نشد'}
      </AlertTitle>
      {message}
      {apiError?.requestId ? (
        <Typography variant="caption" component="p" sx={{ mt: 1, opacity: 0.8 }}>
          کد پیگیری: <code dir="ltr">{apiError.requestId}</code>
        </Typography>
      ) : null}
    </Alert>
  )
}
